<template>
  <component
    :is="proxiedComponentName"
    v-if="$visibility <= 1"
    :id="id"
    :resFunction="resourceTypeFunction"
    :propertyType="property"
    :value="value"
    :htmlId="htmlId"
    :meta="meta"
    :lock="lock"
    :visibility="$visibility"
    :editType="editType"
    @input="change"
    @labelOptions="labelOptions"
    @delete="onDelete"
  ></component>
  <div v-else
       class="asd-input not-allowed-to-edit"
  >
    Nemáte právo videt hodnotu ani editovat
  </div>
</template>

<script>
import Date from '../data-type/date/input'
import DateTime from '../data-type/date-time/input'
import StaticString from '../data-type/static-string/input'
import Boolean from '../data-type/boolean/input'
import Interval from '../data-type/interval/input'

import LinkUser from '../data-type/link-user/input'
import LinkPerson from '../data-type/link-user/input'

import LinkPersonResource from '../data-type/link-resource/input'
import LinkThingResource from '../data-type/link-resource/input'
import LinkPlaceResource from '../data-type/link-resource/input'

import Numeric from '../data-type/numeric/input'
import Trigger from '../data-type/trigger/input'
import Color from '../data-type/color/input'
import Url from '../data-type/url/input'
import Enum from '../data-type/enum/input'
import Link from '../data-type/link/input'
import Longtext from '../data-type/longtext/input'
import EntityState from '../data-type/entity-state/input'

import _ from 'lodash'
import { uuid } from 'vue-uuid'
import { currentTimestamp } from 'CORE/utils/date'

export default {
    name: 'InputProxy',
    components: {
        Date,
        DateTime,
        StaticString,
        Boolean,
        Interval,
        LinkUser,
        LinkPerson,
        LinkPersonResource,
        LinkThingResource,
        LinkPlaceResource,
        Numeric,
        Trigger,
        Color,
        Url,
        Enum,
        Link,
        Longtext,
        EntityState,
    },
    props: {
        id: {
            required: true,
            type: String,
        },
        value: {
            type: Object,
            required: false,
            default: _ => null,
        },
        htmlId: {
            type: String,
            required: false,
            default: _ => uuid.v4(),
        },
        meta: {
            required: false,
            type: Object,
            default: _ => {return {}},
        },
        lock: {
            required: false,
            type: Object,
            default: _ => {return {}},
        },
        editType: {
            required: false,
            type: String,
            default: _ => 'edit',
            validator: value => {
                if (_.indexOf(['edit', 'new'], value) === -1) {
                    console.warn('editType MUST be one of [new, edit]')
                    return false
                }
                return true
            },
        },
    },
    data() {
        return {
            resourceFunction: null,
            lastUpdate: undefined,
        }
    },
    computed: {
        proxiedComponentName() {
            return _.chain(this.property)
                .get('type', 'StaticString')
                .camelCase()
                .upperFirst()
                .value()
        },
        property() {
            return this.$store.getters.propertyTypeByKey(this.id)
        },
        resourceTypeFunction() {
            const type = _.get(this.property, 'type')
            if (type) {
                return _.lowerCase(this.property.type.split('_')[1])
            } else {
                return null
            }
        },
        entity() {
            return this.$route.params.id
        },
        $visibility() {
            return _.get(this.property, '$visibility', 0)
        },
    },
    mounted() {
        this.$emit('isHidden', _.get(this, 'value.$hidden', false))
    },
    methods: {
        change(e) {
            this.$emit('input', e)
            this.lastUpdate = currentTimestamp()
        },
        labelOptions(e) {
            this.$emit('labelOptions', e)
        },
        onDelete(e) {
            this.$emit('delete', this.id)
        },
    },
}
</script>

<style lang="scss" scoped>
.not-allowed-to-edit {
    line-height: 1rem;
    text-align: center;
    border-style: dashed;
    border-color: #ff4500;
}
</style>
